import { useMediaQuery } from '@uidotdev/usehooks'

export enum Breakpoint {
  unlimited = Infinity,
  phase1 = 1130,
  phase2 = 920,
}

export const useBreakpoint = (breakpoint: Breakpoint) => {
  return useMediaQuery(`(max-width: ${breakpoint}px)`)
}
